var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"video"},[_c('video',{ref:"video",attrs:{"id":"video"},on:{"click":function($event){return _vm.navigateTo(_vm.renderModel.url)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }